/* eslint-disable*/

import { Box, colors } from '@material-ui/core'; // eslint-disable-line
import { useSelector } from 'react-redux';
import {
  selectAmazonCategoryGraph,
  selectRakutenCategoryGraph,
  selectYahooCategoryGraph,
  categorygraphStatus
} from 'feactures/category/categoryGraphSlice';
import { currentchannel } from 'feactures/channel/channelSlice';
import CategoryTotalgraph from 'components/molecules/dashboard/CategoryTotalgraph';
import CategoryTotalSales from 'components/molecules/dashboard/CategoryTotalSales';
import { useState } from 'react';

const CategoryTotal = (props) => {
  // 実際のデータはuseEffectで取得しreduxへ
  const { yokoziku } = props;
  let categoryAmazonGraphData = useSelector(selectAmazonCategoryGraph);
  let categoryRakutenGraphData = useSelector(selectRakutenCategoryGraph);
  const categoryYahooGraphData = useSelector(selectYahooCategoryGraph);
  const loading = useSelector(categorygraphStatus);
  const channel = useSelector(currentchannel);
  let yoko = [...yokoziku];
  const [tanni, setTanni] = useState('億円');

  let categoryGraphData = {
    graphdata: [],
    totalsalesData: '',
    totalunitData: '',
    selectCategoryLabel: '',
    lastmonthRate: '',
    lastyearRate: ''
  };
  let mall = '';
  let color = '';
  let categories = '';

  if (channel == 1) {
    // Amazonは2023/2以前は表示させない
    const targetDate = '2023/2';
    const index = yokoziku.findIndex((date) => date === targetDate);
    if (index !== -1 && categoryAmazonGraphData.graphdata.length > 0) {
      yoko.splice(0, index + 1);
      let newData = JSON.parse(JSON.stringify(categoryAmazonGraphData)); // オブジェクト全体をコピー
      newData.graphdata.splice(0, index + 1); // graphdataを変更
      categoryAmazonGraphData = newData; // 新しいオブジェクトを代入
    }

    categoryGraphData = categoryAmazonGraphData;
  } else if (channel == 2) {
    // 楽天は2023/7以前は表示させない
    const targetDate = '2023/7';
    const index = yokoziku.findIndex((date) => date === targetDate);
    if (index !== -1 && categoryRakutenGraphData.graphdata.length > 0) {
      yoko.splice(0, index + 1);
      let newData = JSON.parse(JSON.stringify(categoryRakutenGraphData)); // オブジェクト全体をコピー
      newData.graphdata.splice(0, index + 1); // graphdataを変更
      categoryRakutenGraphData = newData; // 新しいオブジェクトを代入
    }

    categoryGraphData = categoryRakutenGraphData;
  } else if (channel == 3) {
    categoryGraphData = categoryYahooGraphData;
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ flex: '0 0 auto', mb: 0.5 }}>
        <CategoryTotalSales sales={categoryGraphData.totalsalesData} />
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, width: '100%' }}>
        <CategoryTotalgraph
          graphdata={categoryGraphData.graphdata}
          yokoziku={yoko}
          setTanni={setTanni}
        />
      </Box>
    </Box>
  );
};

export default CategoryTotal;
